"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Highlighted = void 0;
var _ = require("lodash");
var React = require("react");
var Highlighted_styles_1 = require("./Highlighted.styles");
var Highlighted = function (_a) {
    var Text = _a.Text, _b = _a.Highlight, Highlight = _b === void 0 ? "" : _b, _c = _a.Ignore, Ignore = _c === void 0 ? "" : _c, _d = _a.Index, Index = _d === void 0 ? null : _d;
    if (!Text) {
        return null;
    }
    if (!Highlight.trim()) {
        return React.createElement(Highlighted_styles_1.Wrapper, null, Text);
    }
    var highlightRgx = "" + _.escapeRegExp(Highlight).split("").map(function (c) {
        return c === "\\" ? c : c + "[" + Ignore + "]*";
    }).join("");
    if (Index === null || Index === undefined) {
        var regex_1 = new RegExp("(" + highlightRgx + ")", "gi");
        var parts = Text.split(regex_1);
        return (React.createElement(Highlighted_styles_1.Wrapper, null, parts
            .filter(function (part) { return part; })
            .map(function (part, i) { return (Boolean(part.match(regex_1)) ? React.createElement("mark", { key: i }, part) : React.createElement("span", { key: i }, part)); })));
    }
    else if (Index >= Text.length || Index < 0) {
        return (React.createElement(Highlighted_styles_1.Wrapper, null, Text));
    }
    else {
        var regex_2 = new RegExp("(" + highlightRgx + ")(.*)", "i");
        var parts = __spreadArray([{ text: Text.slice(0, Index), start: 0 }], (Text.slice(Index).split(regex_2).map(function (text) { return ({ text: text, start: Index }); })));
        var highlightedNumber_1 = 0; // limit highlighted part to 1
        return (React.createElement(Highlighted_styles_1.Wrapper, null, Text.match(regex_2) ? parts
            .filter(function (part) { return part.text !== ""; })
            .map(function (part, i) {
            if (part.start >= Index && highlightedNumber_1 === 0 && Boolean(part.text.match(regex_2))) {
                highlightedNumber_1++;
                return React.createElement("mark", { key: i }, part.text);
            }
            else {
                return React.createElement("span", { key: i }, part.text);
            }
        }) : Text));
    }
};
exports.Highlighted = Highlighted;
